import { keyframes } from "styled-components";
export const FadeInAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
export const FadeOutAnimation = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
//# sourceMappingURL=FadeAnimation.js.map